import React, { useEffect, useState } from "react";
import { useGuidedTour } from "@/lib/guidedTour";
import { useNarrationCue } from "@/components/clientDemo/tour/TourCuePointer";
import { IntakeQueueCard, LifePassCard, ProfileBedCard, VisionBaselineCard } from "./IntakeCards";

export const INTAKE_CUES = [
  { phrase: "Intake Queue", target: "exchange-intake-card-queue" },
  { phrase: "full profile", target: "exchange-intake-card-profile" },
  { phrase: "C2C Vision Baseline", target: "exchange-intake-card-c2c" },
  { phrase: "Life Pass goes live", target: "exchange-intake-card-lifepass" },
];
const CARDS = [IntakeQueueCard, ProfileBedCard, VisionBaselineCard, LifePassCard];

// Beat 03 — each card replays its mini-simulation the moment the narration names it.
export default function ExchangeIntakeSection() {
  const { isActive, current } = useGuidedTour();
  const live = isActive && current?.id === "beat03";
  const cue = useNarrationCue(INTAKE_CUES.map((c) => c.phrase), live);
  const [runs, setRuns] = useState([0, 0, 0, 0]);
  useEffect(() => {
    if (cue >= 0) setRuns((r) => r.map((n, i) => (i === cue ? n + 1 : n)));
  }, [cue]);

  return (
    <section data-testid="exchange-intake-section" className="mt-8 rounded-3xl border border-[#D4AF37]/20 bg-[#0A0612] p-6 md:p-8">
      <div className="mb-6">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#C9A227]">// 06 · Process</div>
        <h2 className="mt-1 text-2xl md:text-3xl font-extrabold tracking-tight text-white">Intake Process</h2>
      </div>
      <div className="flex gap-6">
        <div className="flex-1 min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
          {CARDS.map((Card, i) => <Card key={i} run={runs[i]} active={live && cue === i} />)}
        </div>
        <aside data-testid="exchange-intake-dock" className="hidden xl:flex w-[440px] shrink-0 rounded-2xl border border-dashed border-[#D4AF37]/25 bg-[#D4AF37]/[0.03] p-6 flex-col justify-center">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#C9A227]">From application to Life Pass</div>
          <ol className="mt-4 space-y-3 text-sm text-slate-300 list-decimal list-inside">
            <li>Triage the Intake Queue, urgent first</li>
            <li>Build the profile and lock in a bed</li>
            <li>Capture the C2C Vision Baseline</li>
            <li>Activate the Life Pass and Sprint Phase 1</li>
          </ol>
        </aside>
      </div>
    </section>
  );
}
